import React from 'react';
import { connect } from 'react-redux';
import { userActions } from '../_actions';
import './RegisterUser.css';

class RegisterUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: {
                // firstName: '',
                // lastName: '',
                username: '',
                password: '',
                password2: '',
            },
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const { name } = event.target;
        const { user } = this.state;
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({ submitted: true });
        const { user } = this.state;
        const { dispatch } = this.props;
        if (user.username && user.password && user.password2 && (user.password2 == user.password)) {
            dispatch(userActions.register2(user));
        }
    }

    render() {
        const { registering  } = this.props;
        const { user, submitted } = this.state;
        return (
            <form name="form" onSubmit={this.handleSubmit}>
                <div className={'form-group mb-16' + (submitted && !user.username ? ' has-error' : '')}>
                    <div class="input-wrapper">
                        <input type="text" class="form-control" name="username" placeholder="Enter user name" value={user.username} onChange={this.handleChange} />
                        <button type="button" className="close-btn" aria-label="Close" onClick={() => {
                                this.setState({
                                    user: {
                                        username: '',
                                    },
                                    submitted: false
                                });
                            }}>
                            <i className="fas fa-times"></i>
                        </button>
                    </div>
                    {submitted && !user.username &&
                        <div className="help-block">Username is required</div>
                    }
                </div>
                <div className={'form-group mb-16' + (submitted && (user.password?.length < 8) ? ' has-error' : '')}>
                    <div class="input-wrapper">
                        <input type="password" className="form-control" name="password" placeholder="Enter password" value={user.password} onChange={this.handleChange} />
                            <button type="button" className="close-btn" aria-label="Close" onClick={() => {
                                    this.setState({
                                        user: {
                                            password: '',
                                        },
                                        submitted: false
                                    });
                                }}>
                                <i className="fas fa-times"></i>
                            </button>
                    </div>
                    {submitted && (user.password?.length < 8) &&
                        <div className="help-block">Password minimum length 8 is required</div>
                    }
                </div>
                <div className={'form-group mb-16' + (submitted && (user.password2 != user.password) ? ' has-error' : '')}>
                    <div class="input-wrapper">
                        <input type="password" className="form-control" name="password2" placeholder="Re-enter password" value={user.password2} onChange={this.handleChange} />
                            <button type="button" className="close-btn" aria-label="Close" onClick={() => {
                                    this.setState({
                                        user: {
                                            password2: '',
                                        },
                                        submitted: false
                                    });
                                }}>
                                <i className="fas fa-times"></i>
                            </button>
                    </div>
                    {submitted && user.password && (user.password2 != user.password) &&
                        <div className="help-block">Passwords are Not Equal</div>
                    }
                </div>

                <div className="form-group mb-16">
                    <div className="checkbox-wrapper">
                        <label htmlFor="isAdmin">IsAdmin</label>
                        <input type="checkbox" name="isAdmin" value={user.isAdmin} onChange={this.handleChange} 
                            style={{
                                width: '16px',
                                height: '16px',
                                verticalAlign: 'middle',
                            }}/>
                    </div>
                </div>                    

                <div className="form-group">
                    <button className="btn btn-primary">Save</button>
                    {registering && 
                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                    <button className="btn btn-link ms-16" type="button" onClick={() => {
                        this.setState({
                            user: {
                                username: '',
                                password: '',
                                password2: '',
                            },
                            submitted: false
                        });
                    }}>Cancel</button>
                </div>
            </form>
        );
    }
}

function mapStateToProps(state) {
    const { registering } = state.registration;
    return {
        registering
    };
}

export default connect(mapStateToProps)(RegisterUser);
